// extracted by mini-css-extract-plugin
export var formLbl = "contact-module--formLbl--2NpeD";
export var formBtnLi = "contact-module--formBtnLi--39MaP";
export var formField = "contact-module--formField--1dnNC";
export var formBtn = "contact-module--formBtn--3UOSo";
export var contactForm = "contact-module--contactForm--3Rha3";
export var imageDesign = "contact-module--imageDesign--3T15L";